import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const Loader = ({height=90,paddingLeft=0,paddingRight=0}) => {

  // console.log(levelColors[level]);
  return (
    <Box sx={{
    
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: `${height}vh`,
    width:'100%',
    paddingLeft:`${paddingLeft}rem`,
    paddingRight:`${paddingRight}rem`,
    marginLeft:``
      }}>
      <CircularProgress size="8vw"  />
      </Box>
  )
}

export default Loader